import BusinessCenterCompaniesDataTable from "../../../components/dataTable/tables/BusinessCenterCompaniesDataTable";

function BusinessCenterCompaniesPageView() {
  return <BusinessCenterCompaniesDataTable />;
}

export default BusinessCenterCompaniesPageView;
